module.exports = __webpack_public_path__ + "static/media/kanba.499b769e.JPG";